module.exports = __webpack_public_path__ + "static/img/fun_item1.d867214.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fun_item1.png
// module id = I/s+
// module chunks = 1